﻿import React from 'react';
import { connect } from 'react-redux';
import { VeilederIasAppState } from '../Store';
import { toggleForeldreansvar } from '../Store/Valg/Actions';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import * as ValgTypes from '../Store/Valg/Types';

interface ModalKlikkPropsOwnProps {
    valg: ValgTypes.ValgState;
    lenketekst: JSX.Element | null;
    overskrift: JSX.Element | null;
    content: JSX.Element | null;
    ariaLabel: string;
    eventId: string | null;
}

type ModalKlikkProps = MapStateToProps & MapDispatchToProps & ModalKlikkPropsOwnProps;

class ModalKlikkComponent extends React.PureComponent<ModalKlikkProps> {
    constructor(props: ModalKlikkProps) {
        super(props);
        this.onForeldreansvarClick = this.onForeldreansvarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleForeldreansvar();
    }

    onForeldreansvarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleForeldreansvar();
    }

    render(): JSX.Element {
        const { visForeldreansvar, lenketekst, overskrift, content, ariaLabel, eventId } = this.props;

        return (
            <div className="c-veileder__content-custom c-veileder__content--linkarea">
                <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onForeldreansvarClick}>
                    {lenketekst}
                </button>
                <ModalCompontent
                    isOpen={visForeldreansvar}
                    onRequestClose={this.onRequestClose}
                    ariaCloseText={ariaLabel}
                    eventId={eventId}
                >
                    <ArticleContentComponent headerinnhold={overskrift} contentinnhold={content} />
                </ModalCompontent>
            </div>
        );
    }
}

interface MapStateToProps {
    visForeldreansvar: boolean;
}

interface MapDispatchToProps {
    toggleForeldreansvar: typeof toggleForeldreansvar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederIasAppState): MapStateToProps => {
        return {
            visForeldreansvar: state.valg.visForeldreansvar,
        };
    },
    { toggleForeldreansvar, updateZIndex },
)(ModalKlikkComponent);
